export enum DialogType {
  DELETE = 'DELETE',
  MESSAGE = 'MESSAGE',
  MESSAGE_SUCCESS = 'MESSAGE_SUCCESS',
  MESSAGE_FAILED = 'MESSAGE_FAILED'
}
